import { type PostFormFormParticipationByFormIdData } from '@capsicum/common';

import { formApi } from '.';

export type FetchBackOfficeFormParams = {
	formId: string;
	locale: string;
};

export const fetchBackofficeForm = async (
	params: FetchBackOfficeFormParams
): Promise<PostFormFormParticipationByFormIdData> => {
	const api = await formApi;
	const response = await api.postFormFormParticipationByFormId(params);

	return response;
};
